import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.0017 0.0664062L11.1458 1.4826L11.1444 1.48492L11.1387 1.49425L11.1147 1.5335C11.0932 1.56853 11.0609 1.62088 11.0187 1.68826C10.9344 1.82308 10.811 2.01778 10.6566 2.2542C10.3472 2.72806 9.91655 3.36466 9.42885 4.02054C8.93869 4.67972 8.40406 5.34058 7.88721 5.87187C7.3436 6.43067 6.91844 6.74123 6.65382 6.83963C6.31619 6.96518 6.09813 6.99997 6.00001 6.99997H5.00001L5.00001 8.99997L6.00235 8.99997V11H18L18 8.99998H19V6.99997H18C17.9021 6.99997 17.6848 6.96535 17.3483 6.84031C17.0841 6.74218 16.6593 6.4319 16.1157 5.87302C15.599 5.34172 15.0644 4.68075 14.5743 4.02141C14.0867 3.36538 13.656 2.72859 13.3466 2.25459C13.1922 2.01809 13.0688 1.82332 12.9845 1.68846C12.9424 1.62105 12.91 1.56869 12.8885 1.53365L12.8645 1.49438L12.8588 1.48505L12.0017 0.0664062Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 13L22 13L22 15L21 15L21 22H16V17H8V22H3.00001L3 15H2V13Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10 22V19H14V22H10Z"}}]};

const CityAncientFilled = Vue.extend<IconProps>({
  name: 'CityAncientFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'city-ancient-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default CityAncientFilled;
